import { GET_ALL_AGENCY_RENT } from "./actions";

const initialState = {
  agencyRentList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },

  loading: true,
};

const agencyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_AGENCY_RENT:
      return {
        ...state,
        loading: false,
        agencyRentList: payload,
      };

    default:
      return state;
  }
};

export default agencyReducer;
